function buildCreateBody(data, accountId) {
  return {
    data: {
      type: "phones",
      attributes: data,
      relationships: {
        owner: {
          data: {
            type: "account",
            id: accountId
          }
        }
      }
    }
  };
}

function buildUpdateBody(data, phoneId) {
  return {
    data: {
      id: phoneId,
      type: "phones",
      attributes: data
    }
  };
}

export default {
  buildUpdateBody,
  buildCreateBody
};



// WEBPACK FOOTER //
// ./src/API/helpers/phones.js